<div class="container" [ngClass]="{'container_configurator': activePanel === 'configurator', 'has_external_menu': hasExternalMenu}" >
    <header class="header">
        <button class="external-menu-button" iccIconButton appearance="flat-base" *ngIf="hasExternalMenu" (click)="toggleExternalMenu()"><icc-icon name="menu"></icc-icon></button>

        <div class="logo" (click)="goHome()" [class.disabled]="isDisabledActions()" [ngClass]="{'hidden': hasExternalMenu}">
            <img [src]="themeLogo" class="logo__img">
        </div>
        <div class="navBar">
            <div class="breadcrumb" *ngIf="userBoxData.activeScope !== 'complaintb2c'">
                <ng-container  *ngIf="breadcrumb.length > 0">
                    <ng-container *ngFor="let crumb of breadcrumb; let i = index">
                        <span *ngIf="i > 0"> / </span>
                        <ng-container *ngIf="!isLastCrumb(crumb)">
                            <a class="link" [class.disabled]="isDisabledActions()" (click)="redirectTo(crumb.url, crumb.origin)" [title]="crumb.label">{{maxLength(crumb.label, crumb?.maxLength ? crumb.maxLength : 30)}}</a>
                        </ng-container>
                        <ng-container *ngIf="isLastCrumb(crumb)">
                            <span class="link active" [title]="crumb.label">{{maxLength(crumb.label, crumb?.maxLength ? crumb.maxLength : 45)}}</span>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="toRight">
                <div class="smallLogo" [class.disabled]="isDisabledActions()" (click)="goHome()">
                    <img src="{{themeSmallLogo}}" class="smallLogo__img">
                </div>
                <div class="header__divider"></div>
                <div class="toolbar">
                    <icc-announcements [class.disabled]="isDisabledActions()" [data]="userBoxData" [hideButton]="userBoxData.activeScope === 'complaintb2c'"></icc-announcements>
                    <ng-container  *ngIf="userBoxData.activeScope !== 'complaintb2c'">
                        <button iccIconButton appearance="flat-base" *ngIf="project && !project?.canBeEdited" [title]="project?.number"  [class.disabled]="isDisabledActions()" [routerLink]="['/trade/offer',project?.id]">
                            <icc-icon name="document"></icc-icon>
                        </button>
                        <button iccIconButton appearance="flat-base" [class.disabled]="isDisabledActions()" (click)="openCart()" [title]="project?.canBeEdited ? project?.number : ('SALES_DOCUMENT|Nowa oferta' | translate)" *ngIf="(project?.canBeEdited || loaded && canAdd)">
                            <icc-icon [name]="project?.canBeEdited ? 'shopping_cart' : 'add_to_cart'"
                                [iccBadge]="openedDocumentPositionsCounter$ | async" [iccBadgeSize]="(openedDocumentPositionsCounter$ | async) ? 'large' : 'small'" iccBadgeAppearance="primary" [iccBadgeHidden]="!project?.canBeEdited"
                            ></icc-icon>
                        </button>
                        <button iccIconButton appearance="flat-base" [class.disabled]="isDisabledActions()" [iccMenuTriggerFor]="appMenu" [title]="'INTERFACE|Menu' | translate"><icc-icon name="menu"></icc-icon></button>
                    </ng-container>
                </div>
                <icc-user-box *ngIf="userBoxData.activeScope !== 'complaintb2c'" (changedPriceVersion)="onPriceVersionChange($event)" [data]="userBoxData" [disableActions]="isDisabledActions()" [condensedUserMenu]="condensedUserMenu"></icc-user-box>
            </div>
        </div>
    </header>

    <icc-menu #appMenu="iccMenu" xPosition="before" yPosition="below" >
        <p class="icc-menu-group" *ngIf="hasAccessTo.salesHeader">{{ 'TRADE|Sprzedaż' | translate }}</p>
        <button icc-menu-item routerLink="/trade/offer/list/orders/sales" [queryParams]="{first: true}" *ngxPermissionsOnly="['sell-own-orders-list', 'sell-all-orders-list', 'sell-resource-all-orders-list']">
            <span>{{ 'SALES_DOCUMENT|Lista zamówień klientów końcowych' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/offer/list/offers" [queryParams]="{first: true}" *ngxPermissionsOnly="['sell-own-quotations', 'sell-all-quotations-list', 'sell-resource-all-quotations-list']">
            <span>{{ 'SALES_DOCUMENT|Lista ofert' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/offer/list/inquiries/sales" [queryParams]="{first: true}" *ngIf="hasAccessTo.saleInquiriesList">
            <span>{{ 'SALES_DOCUMENT|Lista zapytań ofertowych klientów końcowych' | translate }}</span>
        </button>
        <button *ngIf="hasAccessTo.productsList" icc-menu-item routerLink="/trade/products" >
            <span>{{ 'PRODUCT|Lista produktów' | translate }}</span>
        </button>
        <a icc-menu-item href="/iccadmin/icadmin/product/products/index-addon/index" *ngIf="hasPermissionsForOwnProducts()" >
            <span>{{ 'PRODUCT|Produkty własne' | translate }}</span>
        </a>
        <a iccDisabled *ngIf="hasAccessTo.productsList" icc-menu-item (click)="redirectTo('/trade/configurators')" >
            <span>{{ 'CONFIGURATOR|Konfiguratory' | translate }}</span>
        </a>
        <p class="icc-menu-group" *ngIf="hasAccessTo.ordersList || hasAccessTo.unplacedOrdersList || hasAccessTo.purchaseInquiriesList">{{ 'TRADE|Zakup' | translate }}</p>
        <button icc-menu-item routerLink="/trade/offer/list/orders/purchase" [queryParams]="{first: true}" *ngIf="hasAccessTo.ordersList">
            <span>{{ 'SALES_DOCUMENT|Lista zamówień u dostawcy' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/offer/list/orders/unplaced" [queryParams]="{first: true}" *ngIf="hasAccessTo.unplacedOrdersList">
            <span>{{ 'SALES_DOCUMENT|Lista zamówień u dostawcy do potwierdzenia' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/offer/list/inquiries/purchase" [queryParams]="{first: true}" *ngIf="hasAccessTo.purchaseInquiriesList">
            <span>{{ 'SALES_DOCUMENT|Lista zapytań ofertowych u dostawcy' | translate }}</span>
        </button>
        <p class="icc-menu-group" *ngxPermissionsOnly="['complaints-manage']">{{ 'TRADE|Reklamacje' | translate }}</p>
        <button icc-menu-item routerLink="/trade/complaint/list/complaints" [queryParams]="{first: true}" *ngxPermissionsOnly="['complaints-all-preview', 'complaints-own-preview']">
            <span>{{ 'COMPLAINT|Lista reklamacji' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/offer/list/service-orders" [queryParams]="{first: true}" *ngxPermissionsOnly="['all-service-orders-list']">
            <span>{{ 'SALES_DOCUMENT|Lista zamówień serwisowych' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/trade/complaint/list/appointments" [queryParams]="{first: true}" *ngxPermissionsOnly="['complaints-all-preview', 'complaints-own-preview']">
            <span>{{ 'COMPLAINT|Lista wizyt' | translate }}</span>
        </button>
        <ng-container *ngIf="isSublicense">
            <button icc-menu-item (click)="reloadB2bComplaintForm('/trade/complaint-form-internal')" *ngxPermissionsOnly="['complaints-manage']">
                <span>{{ 'COMPLAINT|Wewnętrzny formularz reklamacji' | translate }}</span>
            </button>
        </ng-container>
        <p class="icc-menu-group">{{ 'TRADE|Pozostałe' | translate }}</p>
        <button icc-menu-item routerLink="/complaint-v1/complaints" [queryParams]="{first: true}" *ngxPermissionsOnly="['trade-request-complaint-v1', 'trade-complaint-v1-manage']">
            <span>{{ 'COMPLAINT|Lista zgłoszeń reklamacji' | translate }}</span>
        </button>
        <button icc-menu-item routerLink="/transport/transports" [queryParams]="{first: true}" *ngxPermissionsOnly="['trade-request-transport', 'trade-transport-manage']">
            <span>{{ 'TRANSPORT|Lista zgłoszeń transportowych' | translate }}</span>
        </button>
        <button  iccDisabled icc-menu-item >
            <span>{{ 'TRADE|Lista handlowców' | translate }}</span>
        </button>
        <p class="icc-menu-group">{{ 'INTERFACE|Pozostałe' | translate }}</p>
        <button icc-menu-item routerLink="/trade/pages" >
            <span>{{ 'PAGE|Informacje' | translate }}</span>
        </button>
        <a *ngIf="consent?.img" icc-menu-item href="/files/consents/{{consent.img}}" target="_blank">
            <span>{{ 'TRADE|Regulamin' | translate }}</span>
        </a>
    </icc-menu>

</div>
